import { useEffect, useState } from 'react'

const STORAGE_KEY = 'mangaos-runners-hidden'

function getInitialHidden() {
  if (typeof window === 'undefined') return false
  return window.localStorage.getItem(STORAGE_KEY) === '1'
}

export default function RunnerToggleButton() {
  const [hidden, setHidden] = useState(getInitialHidden)

  useEffect(() => {
    const sync = () => setHidden(getInitialHidden())

    window.addEventListener('storage', sync)
    window.addEventListener('mangaos-runners-change', sync)

    return () => {
      window.removeEventListener('storage', sync)
      window.removeEventListener('mangaos-runners-change', sync)
    }
  }, [])

  useEffect(() => {
    if (hidden) {
      window.localStorage.setItem(STORAGE_KEY, '1')
    } else {
      window.localStorage.removeItem(STORAGE_KEY)
    }

    window.dispatchEvent(new Event('mangaos-runners-change'))
  }, [hidden])

  return (
    <button
      type="button"
      className="btn btn-outline btn-sm runner-toggle-btn"
      onClick={() => setHidden((current) => !current)}
      title={hidden ? '下部の走る人を表示します' : '下部の走る人を非表示にします'}
    >
      {hidden ? '人間 ON' : '人間 OFF'}
    </button>
  )
}
